import { useContext } from 'react'

import { CONTENT_TYPES } from '@scoir/college-content'

import ContentModalContext from '../../ContentModalProvider/Context'
import { FIELD_NAMES, LABELS } from '../../components/constants'
import Section from '../../components/Section'
import Virtual from './Virtual'
import Location from './Location'
import RegistrationLink from './RegistrationLink'

const Type = () => {
  const { type } = useContext(ContentModalContext)
  const displayRegistrationURL = type === CONTENT_TYPES.SESSIONS
  return (
    <Section title="Type">
      <Virtual />
      <Location />
      {displayRegistrationURL && (
        <RegistrationLink
          label={LABELS.REGISTRATION}
          fieldName={FIELD_NAMES.LINK}
        />
      )}
    </Section>
  )
}

export default Type
